export default
{
    "standardEnemies" : [
        {
            name : "Rodent of Unusual Size",
            introduction : "You come upon a rodent of unusual size.",
            id : "serous001",
            levelRange  : 1,
            speech : "'What the he- I mean.. squeak?'",
            image : require("../../assets/images/enemyimages/rodentofunusualsize.png"),
            deathImage : require("../../assets/images/enemyimages/rodentofunusualsizedead.png"),
        },
        {
            name : "Young Rockling",
            introduction : "You come upon a young rockling.",
            id : "rockling001",
            levelRange  : 1,
            speech : "'Hissssssss' it says, inexplicably.",
            image : require("../../assets/images/enemyimages/rocklingidle.png"),
            deathImage : require("../../assets/images/enemyimages/rocklingdead.png"),
        },
        {
            name : "Hedgepig",
            introduction : "You come upon a hedgepig.",
            id : "hedge001",
            levelRange  : 1,
            speech : "Well, at least it isn't blue..",
            image : require("../../assets/images/enemyimages/hedgepigidle.png"),
            deathImage : require("../../assets/images/enemyimages/hedgepigdead.png"),
        },
        {
            name : "Boar",
            introduction : "Oh look, walking bacon. You monster.",
            id : "boar001",
            levelRange  : 1,
            speech : "'Uh.. oink?'",
            image : require("../../assets/images/enemyimages/boaridle.png"),
            deathImage : require("../../assets/images/enemyimages/boardead.png"),
        },
        {
            name : "Monkey",
            introduction : "Watch out for flying.. bananas.",
            id : "monkey001",
            levelRange  : 1,
            speech : "I think it just winked at you.",
            image : require("../../assets/images/enemyimages/monkeyidle.png"),
            deathImage : require("../../assets/images/enemyimages/monkeydead.png"),
        },
        {
            name : "Piranha",
            introduction : "What is this thing doing on land?",
            id : "piranha001",
            levelRange  : 1,
            speech : "It looks pissed off and hungry. Better eat it first.",
            image : require("../../assets/images/enemyimages/piranhaidle.png"),
            deathImage : require("../../assets/images/enemyimages/piranhadead.png"),
        },
        {
            name : "Snail",
            introduction : "The French would consider this a winfall.",
            id : "snail001",
            levelRange  : 1,
            speech : "'Do you like omelets? Du fromage?!'",
            image : require("../../assets/images/enemyimages/snailidle.png"),
            deathImage : require("../../assets/images/enemyimages/snaildead.png"),
        },
        {
            name : "Turtle",
            introduction : "He's been looking forward to this all day.",
            id : "turtle01",
            levelRange  : 1,
            speech : "'Let's try spinning. That's a good trick.'",
            image : require("../../assets/images/enemyimages/turtleidle.png"),
            deathImage : require("../../assets/images/enemyimages/turtledead.png"),
        },
        {
            name : "Bombling",
            introduction : "Nobody knows why he carries a sword.",
            id : "bombling001",
            levelRange  : 1,
            speech : "'My main goal.. is to blow up.'",
            image : require("../../assets/images/enemyimages/bomblingidle.png"),
            deathImage : require("../../assets/images/enemyimages/bomblingdead.png"),
        },
        {
            name : "Batling",
            introduction : "It's like a bat, only cuter. Steel yourself.",
            id : "batling001",
            levelRange  : 1,
            speech : "It keep staring at your neck for some reason.",
            image : require("../../assets/images/enemyimages/batlingidle.png"),
            deathImage : require("../../assets/images/enemyimages/batlingdead.png"),
        },
        {
            name : "Demonling",
            introduction : "Fresh out of hell. No, seriously.",
            id : "demonling001",
            levelRange  : 1,
            speech : "'What are you looking at?'",
            image : require("../../assets/images/enemyimages/demonlingidle.png"),
            deathImage : require("../../assets/images/enemyimages/demonlingdead.png"),
        },
        {
            name : "Dragonling",
            introduction : "A very small dragon. Or so he says.",
            id : "dragonling001",
            levelRange  : 1,
            speech : "I hope his mom isnt nearby..",
            image : require("../../assets/images/enemyimages/dragonlingidle.png"),
            deathImage : require("../../assets/images/enemyimages/dragonlingdead.png"),
        },
        {
            name : "Fireling",
            introduction : "Proud citizen of California.",
            id : "fireling001",
            levelRange  : 1,
            speech : "'You like fireworks?'",
            image : require("../../assets/images/enemyimages/firelingidle.png"),
            deathImage : require("../../assets/images/enemyimages/firelingdead.png"),
        },
        {
            name : "Grassling",
            introduction : "You woke him up from his nap.",
            id : "grassling001",
            levelRange  : 1,
            speech : "'Get off my lawn.'",
            image : require("../../assets/images/enemyimages/grasslingidle.png"),
            deathImage : require("../../assets/images/enemyimages/grasslingdead.png"),
        },
        {
            name : "Hairling",
            introduction : "Your shower drain, brought to life.",
            id : "hairling001",
            levelRange  : 1,
            speech : "'Wanna start a metal band?'",
            image : require("../../assets/images/enemyimages/hairlingidle.png"),
            deathImage : require("../../assets/images/enemyimages/hairlingdead.png"),
        },
        {
            name : "Mudling",
            introduction : "If he offers you a pie, DO NOT EAT IT.",
            id : "mudling001",
            levelRange  : 1,
            speech : "'How do you feel about baked goods?'",
            image : require("../../assets/images/enemyimages/mudlingidle.png"),
            deathImage : require("../../assets/images/enemyimages/mudlingdead.png"),
        },
        {
            name : "Ogreling",
            introduction : "A baby ogre. Or a child in costume. Only one way to find out.",
            id : "ogreling001",
            levelRange  : 1,
            speech : "'TRICK OR TREAT?!'",
            image : require("../../assets/images/enemyimages/ogrelingidle.png"),
            deathImage : require("../../assets/images/enemyimages/ogrelingdead.png"),
        },
        {
            name : "Rhinoling",
            introduction : "There aren't many of these guys around..",
            id : "rhinoling001",
            levelRange  : 1,
            speech : "It polishes its horn and stares at you.",
            image : require("../../assets/images/enemyimages/rhinolingidle.png"),
            deathImage : require("../../assets/images/enemyimages/rhinolingdead.png"),
        },
        {
            name : "Spotling",
            introduction : "It's weaving a little..",
            id : "spotling001",
            levelRange  : 1,
            speech : "'You got any *hick* grape juice?'",
            image : require("../../assets/images/enemyimages/spotlingidle.png"),
            deathImage : require("../../assets/images/enemyimages/spotlingdead.png"),
        },
    ]
};
